export default __webpack_public_path__ + "static/iosGateIllustration-53f07e2a9c5f39be006f725c6fed5a2a.svg";